var BetResponseCode;
(function (BetResponseCode) {
    BetResponseCode[BetResponseCode["Success"] = 0] = "Success";
    BetResponseCode[BetResponseCode["GeneralError"] = 1] = "GeneralError";
    BetResponseCode[BetResponseCode["InValidMinBet"] = 2] = "InValidMinBet";
    BetResponseCode[BetResponseCode["InValidMaxBet"] = 3] = "InValidMaxBet";
    BetResponseCode[BetResponseCode["InvalidBet"] = 4] = "InvalidBet";
    BetResponseCode[BetResponseCode["NotEnoughBalance"] = 5] = "NotEnoughBalance";
    BetResponseCode[BetResponseCode["MoneyTransactionError"] = 6] = "MoneyTransactionError";
    BetResponseCode[BetResponseCode["UnAuthorizedUser"] = 7] = "UnAuthorizedUser";
    BetResponseCode[BetResponseCode["InvalidBetTime"] = 8] = "InvalidBetTime";
    BetResponseCode[BetResponseCode["InvalidRoundId"] = 9] = "InvalidRoundId";
    BetResponseCode[BetResponseCode["InValidBetData"] = 10] = "InValidBetData";
    BetResponseCode[BetResponseCode["InValidToken"] = 11] = "InValidToken";
})(BetResponseCode || (BetResponseCode = {}));

export { BetResponseCode };
